import React, { Component } from "react";
import {
  Button,
  Comment,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Item,
  Label,
  List,
  Message,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { fetchJsonData } from "../../helpers/fetchJsonData";
import Footer from "./footer";
import Sidebar from "./sidebar";
import HeaderInfo from "./header";

class ArticleHelperComponent extends Component {
  render() {
    return (
      <div>
        <h1>Article Helper Component</h1>
        <p>This is a sample article helper component.</p>
      </div>
    );
  }
}

export class FeaturedArticle extends Component {
  render() {
    return (
      <div className="featured-headline">
        <Link to="/articles/first_article">
          <Image
            src="https://user-images.githubusercontent.com/74038190/225813708-98b745f2-7d22-48cf-9150-083f1b00d6c9.gif"
            centered
            size="huge"
          />
          <Header as="h1">
            Some cool article title here
            <Header.Subheader>
              Subheader here, some cool description
            </Header.Subheader>
          </Header>
        </Link>
        <Header as="h5">
          <Image circular src="/static/images/gerard_formal.jpg" />
          <Header.Content>
            Gerard Gueco in Medium Education Blog
            <Header.Subheader>Jan 20 · 4 min read</Header.Subheader>
          </Header.Content>
        </Header>
      </div>
    );
  }
}

export class LatestArticles extends Component {
  articles = [
    {
      href: "/articles/second_article",
      imgSrc:
        "https://user-images.githubusercontent.com/74038190/225813708-98b745f2-7d22-48cf-9150-083f1b00d6c9.gif",
      title: "Some cool article title here",
      meta: "Meta description here",
      extra: "Jan 20 · 4 min read",
    },
    {
      href: "/articles/third_article",
      imgSrc:
        "https://user-images.githubusercontent.com/74038190/225813708-98b745f2-7d22-48cf-9150-083f1b00d6c9.gif",
      title: "Some cool article title here",
      meta: "Meta description here",
      extra: "Jan 20 · 4 min read",
    },
    {
      href: "/articles/fourth_article",
      imgSrc:
        "https://user-images.githubusercontent.com/74038190/225813708-98b745f2-7d22-48cf-9150-083f1b00d6c9.gif",
      title: "Some cool article title here",
      meta: "Meta description here",
      extra: "Jan 20 · 4 min read",
    },
  ];

  render() {
    return (
      <div className="latest-articles">
        <Header as="h3" dividing>
          Latest Stories
        </Header>
        <Item.Group>
          {this.articles.map(({ href, imgSrc, title, meta, extra }, index) => (
            <Item key={index}>
              <Item.Image src={imgSrc} />
              <Item.Content verticalAlign="middle">
                <Item.Header>
                  <Link to={href}>{title}</Link>
                </Item.Header>
                <Item.Meta>{meta}</Item.Meta>
                <Item.Extra>{extra}</Item.Extra>
              </Item.Content>
            </Item>
          ))}
        </Item.Group>
      </div>
    );
  }
}

export class FeaturedStories extends Component {
  render() {
    return (
      <div className="featured-stories">
        <Header as="h2">
          Featured stories
          <Header.Subheader>Today’s best stories.</Header.Subheader>
        </Header>
      </div>
    );
  }
}

export class TitleAuthorHeader extends Component {
  render() {
    const { header_title, header_description } = this.props;

    return (
      <div className="title_author_header">
        <Header as="h1">
          {header_title}
          <Header.Subheader>{header_description}</Header.Subheader>
        </Header>

        <div className="author-header">
          <Header as="h3" floated="left">
            <Header.Content>
              <Header.Subheader>Gerard Gueco</Header.Subheader>
              <Header.Subheader>Jan 20, 2025 · 4 min read</Header.Subheader>
            </Header.Content>
          </Header>

          <Header as="h3" floated="right">
            {this.renderSocialLinks()}
          </Header>
        </div>
      </div>
    );
  }

  renderSocialLinks() {
    const socialLinks = [
      { href: "https://twitter.com/xogerardd", icon: "twitter" },
      {
        href: "https://www.linkedin.com/in/ggueco/",
        icon: "linkedin",
      },
      { href: "https://www.facebook.com/xogerard/", icon: "facebook" },
    ];

    return socialLinks.map(({ href, icon }) => (
      <a key={icon} href={href} target="_blank" rel="noopener noreferrer">
        <Icon name={icon} />
      </a>
    ));
  }
}

export class MassiveImage extends Component {
  render() {
    const { massiveimg_src, massiveimg_cap } = this.props;

    return (
      <div className="massive_image">
        <Image
          // className="full-img"
          src={massiveimg_src}
          centered
          size="massive"
        />
        <p className="center">{massiveimg_cap}</p>
      </div>
    );
  }
}

export class ArticleItems extends Component {
  renderArticleItems() {
    const { article_items } = this.props;

    return article_items.map(
      ({ item_img, item_header, item_desc, item_extra }, i) => (
        <Item key={i}>
          <Item.Image size="small" src={item_img} />
          <Item.Content verticalAlign="middle">
            <Item.Header as="a">{item_header}</Item.Header>
            <Item.Description>{item_desc}</Item.Description>
            <Item.Extra>{item_extra}</Item.Extra>
          </Item.Content>
        </Item>
      )
    );
  }

  render() {
    return (
      <div className="article_items">
        <Item.Group>{this.renderArticleItems()}</Item.Group>
      </div>
    );
  }
}

export class ArticleList extends Component {
  renderArticleList() {
    const { article_list } = this.props;

    return article_list.map(({ list_item }, i) => (
      <List.Item key={i}>{list_item}</List.Item>
    ));
  }

  render() {
    return (
      <div className="article_list">
        <List bulleted>{this.renderArticleList()}</List>
      </div>
    );
  }
}

export class ArticleCode extends Component {
  renderCodeLines() {
    const { code } = this.props;

    return code.split("\n").map((line, i) => (
      <span key={i}>
        {line}
        <br />
      </span>
    ));
  }

  render() {
    return (
      <div className="article_code">
        <Message>
          <code>{this.renderCodeLines()}</code>
        </Message>
      </div>
    );
  }
}

export class InlineImage extends Component {
  render() {
    const { inl_img_src, inl_cap } = this.props;

    return (
      <div className="inline_image">
        <Image src={inl_img_src} centered size="massive" />
        <p className="center">{inl_cap}</p>
      </div>
    );
  }
}

export class ArticleCategories extends Component {
  renderCategories() {
    const { tag } = this.props;

    return tag.map((subData, k) => <Label key={k}>{subData}</Label>);
  }

  render() {
    return (
      <div className="categories">
        <Label.Group size="large">{this.renderCategories()}</Label.Group>
      </div>
    );
  }
}

export class ArticleClaps extends Component {
  renderClapAndComment() {
    return [
      { icon: "thumbs up outline", count: 23 },
      { icon: "comment outline", count: 23 },
    ].map(({ icon, count }, index) => (
      <Label key={index} basic size="medium">
        <Icon size="big" name={icon} />
        {count}
      </Label>
    ));
  }

  renderSocialLinks() {
    const socialLinks = [
      { href: "https://twitter.com/xogerardd", icon: "twitter" },
      {
        href: "https://www.linkedin.com/in/ggueco/",
        icon: "linkedin",
      },
      { href: "https://www.facebook.com/xogerard/", icon: "facebook" },
    ];

    return socialLinks.map(({ href, icon }) => (
      <a key={icon} href={href} target="_blank" rel="noopener noreferrer">
        <Icon size="large" name={icon} />
      </a>
    ));
  }

  render() {
    return (
      <div className="claps">
        <Header as="h4" floated="left">
          {this.renderClapAndComment()}
        </Header>
        <Header as="h4" floated="right">
          {this.renderSocialLinks()}
        </Header>
      </div>
    );
  }
}

export class AboutAuthor extends Component {
  renderAuthorInfo() {
    return (
      <div className="info">
        <Header as="h2">
          <Header.Content>
            <Header.Subheader>Written By</Header.Subheader>
            Gerard Gueco
            <Header.Subheader>Front End Developer</Header.Subheader>
          </Header.Content>
        </Header>
        {this.renderAuthorDescription()}
      </div>
    );
  }

  renderAuthorDescription() {
    const description = `Te eum doming eirmod, nominati pertinacia argumentum ad his. 
        Ex eam alia facete scriptorem, est autem aliquip detraxit at. Usu ocurreret referrentur at, 
        cu epicurei appellantur vix. Cum ea laoreet recteque electram, eos choro alterum definiebas in. 
        Vim dolorum definiebas an. Mei ex natum rebum iisque.`;

    return (
      <>
        <p>{description}</p>
        <p>{description}</p>
      </>
    );
  }

  render() {
    return (
      <div className="author">
        <Grid>
          <Grid.Row>
            <Grid.Column computer={8} mobile={16} tablet={8}>
              <Image
                src="/static/images/GG.png"
                verticalAlign="middle"
                size="medium"
                centered
              />
            </Grid.Column>
            <Grid.Column computer={8} mobile={16} tablet={8}>
              {this.renderAuthorInfo()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export class ArticleComment extends Component {
  renderComment({ avatar, author, time, text, replies = [] }, index) {
    return (
      <Comment key={index}>
        <Comment.Avatar src={avatar} />
        <Comment.Content>
          <Comment.Author as="a">{author}</Comment.Author>
          <Comment.Metadata>
            <div>{time}</div>
          </Comment.Metadata>
          <Comment.Text>{text}</Comment.Text>
          <Comment.Actions>
            <Comment.Action>Reply</Comment.Action>
          </Comment.Actions>
        </Comment.Content>
        {replies.length > 0 && (
          <Comment.Group>
            {replies.map((reply, i) =>
              this.renderComment(reply, `reply-${index}-${i}`)
            )}
          </Comment.Group>
        )}
      </Comment>
    );
  }

  render() {
    const comments = [
      {
        avatar: "/static/images/gerard_formal.jpg",
        author: "Matt",
        time: "Today at 5:42PM",
        text: "How artistic!",
      },
      {
        avatar: "/static/images/gerard_formal.jpg",
        author: "Elliot Fu",
        time: "Yesterday at 12:30AM",
        text: "This has been very useful for my research. Thanks as well!",
        replies: [
          {
            avatar: "/static/images/gerard_formal.jpg",
            author: "Jenny Hess",
            time: "Just now",
            text: "Elliot you are always so right :)",
          },
        ],
      },
      {
        avatar: "/static/images/gerard_formal.jpg",
        author: "Joe Henderson",
        time: "5 days ago",
        text: "Dude, this is awesome. Thanks so much",
      },
    ];

    return (
      <div className="comments">
        <Comment.Group>
          <Header as="h3">Comments</Header>
          {comments.map((comment, index) => this.renderComment(comment, index))}
          <Form reply>
            <Form.TextArea />
            <Button
              content="Add Reply"
              labelPosition="left"
              icon="edit"
              primary
            />
          </Form>
        </Comment.Group>
      </div>
    );
  }
}

export class ArticleHeader extends Component {
  render() {
    const { art_header } = this.props;
    return <Header as="h1">{art_header}</Header>;
  }
}

export class ArticleParagraph extends Component {
  render() {
    const { art_p } = this.props;
    return <p>{art_p}</p>;
  }
}

export class ArticleContent extends Component {
  render() {
    const { article } = this.props;

    if (!article) return null;

    return (
      <div className="article-content">
        <Grid centered>
          <Grid.Row>
            <Grid.Column computer={10} tablet={16} mobile={16}>
              <TitleAuthorHeader
                header_title={article.header}
                header_description={article.header_desc || null}
              />

              {article.preview?.map((subData, j) => (
                <MassiveImage
                  key={j}
                  massiveimg_src={subData.img}
                  massiveimg_cap={subData.caption || null}
                />
              ))}

              <div className="text-content">
                {article.article_content?.map((subData, k) =>
                  Object.entries(subData).map(([key, value]) => {
                    if (key === "article_header")
                      return <ArticleHeader key={k} art_header={value} />;
                    if (key === "p")
                      return <ArticleParagraph key={k} art_p={value} />;
                    if (key === "article_items")
                      return <ArticleItems key={k} article_items={value} />;
                    if (key === "article_list")
                      return <ArticleList key={k} article_list={value} />;
                    if (key === "code")
                      return <ArticleCode key={k} code={value} />;
                    if (key === "inl_img")
                      return value.map((sData, a) => (
                        <InlineImage
                          key={a}
                          inl_img_src={sData.img}
                          inl_cap={sData.caption || null}
                        />
                      ));
                    return null;
                  })
                )}
              </div>

              {article.categories && (
                <ArticleCategories tag={article.categories} />
              )}

              <ArticleClaps />
              <Divider clearing section />
              <AboutAuthor />
              <Divider clearing section />
              <ArticleComment />
              <Footer />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export class ArticlePage extends Component {
  constructor(props) {
    super(props);
    this.state = { menuOpen: false, data: [] };
  }

  async componentDidMount() {
    const jsonData = await fetchJsonData("/static/data/articles.json");
    this.setState({ data: jsonData });
  }

  handleMenuToggle = () => {
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }));
  };

  handleStateChange = (state) => {
    this.setState({ menuOpen: state.isOpen });
  };

  render() {
    const { data } = this.state;
    const { articlenum } = this.props;
    const article = data.find((item) => item.articlenum === articlenum);

    return (
      <div id="App">
        <Sidebar
          pageWrapId="article-content"
          outerContainerId="App"
          isOpen={this.state.menuOpen}
          onStateChange={this.handleStateChange}
          active={"articles"}
        />
        <main id="article-content">
          <Container>
            <div className="header-content">
              <HeaderInfo />
              <Button basic icon size="big" onClick={this.handleMenuToggle}>
                <Icon name="bars" />
              </Button>
            </div>

            <ArticleContent article={article} />
          </Container>
        </main>
      </div>
    );
  }
}

export default ArticleHelperComponent;
